export const CHROME_EXTENSION_STORE_URL =
  'https://chrome.google.com/webstore/detail/kol-radar-ai-%E7%B6%B2%E7%B4%85%E6%95%B8%E6%93%9A%E8%88%87%E5%88%86%E6%9E%90%E5%A4%96%E6%8E%9B%E5%B7%A5%E5%85%B7/amjaoklkeffceamacmpblhhhfajdoihl'
